import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import About from "@/components/sections/About";
import Fuhrpark from "@/components/sections/Fuhrpark";
import Services from "@/components/sections/Services";
import Partners from "@/components/sections/Partners";
import ContactSection from "@/components/sections/ContactSection";
import DealOfDay from "@/components/sections/DealOfDay";
import LocationBanner from "@/components/sections/LocationBanner";
import useSeo from "@/hooks/useSeo";

export default function Home() {
  useSeo({
    title: "DNA Automotive Köln · Premium Fahrzeuge · MotorWorld Köln-Rheinland",
    description: "Premium Fahrzeuge in Köln: Ankauf, Verkauf, Auto-Abo, Mietwagen, Finanzierung ab 4,9 %. Ihr Autohaus in der MotorWorld Köln-Rheinland – Sportwagen, Luxus, Gebrauchtwagen.",
    path: "/",
    image: "/dna-logo-enhanced.png",
  });
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="bg-obsidian min-h-screen" data-testid="home-page">
      <Header />
      <Hero onExplore={() => scrollTo("fuhrpark")} onContact={() => scrollTo("contact")} />
      <Marquee />
      <DealOfDay />
      <Fuhrpark limit={5} />
      <About />
      <LocationBanner />
      <Services />
      <Partners />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
